/**
 * ADM-USERS.ROUTE
 * List of users for one account
 */
import { useState } from "react"
import { WithTranslation, withTranslation } from "react-i18next"
import PageHeader from "@/components/page-header"
import NavApp from "@/nav/nav.app"
import DeleteUsersModal from "@/modals/delete-users.modal"
import ImportUsersModal from "@/modals/import-users.modal"
import AdmUsersWidget from "@/widgets/adm-users.widget"
import Card from "@/components/card"
import { useAppSelector } from "@/core/root-reducer"
import Link from "@/components/link"
import { faPaperPlane, faTrash, faUpload } from "@fortawesome/free-solid-svg-icons"
import UserSendCommunicationModal from "@/modals/user-send-communication.modal"

type Props = WithTranslation

const MODAL_DELETE_ALL = "MODAL_DELETE_ALL" //Display modal to confirm to delete all user
const MODAL_IMPORT = "MODAL_IMPORT" //Options to import users
const MODAL_SEND_COMMUNICATION = "MODAL_SEND_COMMUNICATION"

function AdmUsersRoute(props: Props) {
  const { t } = props
  const _session = useAppSelector((s) => s._session)

  const [currentModal, setCurrentModal] = useState<string | null>(null)

  return (
    <NavApp>
      {currentModal === MODAL_DELETE_ALL && (
        <DeleteUsersModal onClose={() => setCurrentModal(null)} onDeleteSuccess={() => window.location.reload()} />
      )}

      {currentModal === MODAL_IMPORT && (
        <ImportUsersModal
          onClose={() => setCurrentModal(null)}
          onNext={() => {
            window.location.reload()
            setCurrentModal(null)
          }}
        />
      )}

      {currentModal === MODAL_SEND_COMMUNICATION && (
        <UserSendCommunicationModal onClose={() => setCurrentModal(null)} />
      )}

      <PageHeader title={t("users")} subtitle={t("users_help")}>
        {_session.features.survey && (
          <div className="flex gap-10 flex-col">
            <Link isWithoutMargin icon={faUpload} onClick={() => setCurrentModal(MODAL_IMPORT)}>
              <b>{t("user_import")}</b>
            </Link>
            <Link icon={faPaperPlane} isWithoutMargin onClick={() => setCurrentModal(MODAL_SEND_COMMUNICATION)}>
              {t("user_send_communication")}
            </Link>
            <Link icon={faTrash} isWithoutMargin onClick={() => setCurrentModal(MODAL_DELETE_ALL)}>
              {t("user_delete_all")}
            </Link>
          </div>
        )}
      </PageHeader>

      <Card isWithoutPadding>
        <AdmUsersWidget />
      </Card>
    </NavApp>
  )
}

export default withTranslation()(AdmUsersRoute)
